import {Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { Subscription, } from 'rxjs';
import { ApplicationDialogService } from '../application-dialog-component/application-dialog.service';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { Accreditation, AccreditationWebService, CreditorWatchReportData, DEFAULT_LIMIT, DEFAULT_OFFSET, DownloadCreditorWatchReportFn } from '@portal-workspace/grow-shared-library';
import { FlexModule } from '@angular/flex-layout';
import { CustomContentLoaderComponent } from "../custom-content-loader-component/custom-content-loader.component";
import { CustomPaginatorComponent } from '../custom-paginator-component/custom-paginator/custom-paginator.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { loadingFor } from '@ngneat/loadoff';
import { DatePipe, AsyncPipe, } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { bureauReportDownloadTarget, openAuthorizedBureauReport } from '../credit-component/open-bureau-report-download';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'accreditation-web-services',
    templateUrl: './accreditation-web-services.component.html',
    styleUrls: ['./accreditation-web-services.component.scss'],
    standalone: true,
    imports: [
      MatTableModule, 
      NgClass, 
      ExtendedModule, 
      FlexModule,
      CustomContentLoaderComponent,
      CustomPaginatorComponent,
      MatSortModule,
      DatePipe,
      AsyncPipe,
      MatButtonModule,
      MatInputModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatTooltipModule,
    ]
})
export class AccreditationWebServicesComponent implements OnInit, OnChanges {
  @Input({required: true}) data!: AccreditationWebService[];
  @Input({required: true}) accreditation!: Accreditation;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input() apiUrl!: string;
  @Output() viewReport = new EventEmitter<AccreditationWebService>();

  subscriptions: Subscription[] = [];
  moment = moment;
  formControlSearch!: FormControl<string | null>;

  total = 0;
  limit = DEFAULT_LIMIT;
  offset = DEFAULT_OFFSET;
  filter = '';
  loader = loadingFor('tableLoading');
  sorts: { prop: string, dir: 'asc' | 'desc' } | null = null;
  dataSource: AccreditationWebService[] = [];
  columnsToDisplay = ['type', 'lastUpdatedTime', 'report'];

  constructor(
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
  ) {
  }

  ngOnInit(): void {
    this.loadDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadDataSource();
  }

  loadDataSource() {
    this.dataSource = [];
    for (const webService of this.data) {

      this.dataSource.push({
        ...webService,
      })
    }
  }


  getColumnTitles(column: string): string {
    switch (column) {
      case 'type': return 'Type';
      case 'report': return 'Report';
      case 'lastUpdatedTime': return 'Updated Time';
      default: return column;
    }
  }

  onDownloadReport(element: AccreditationWebService) {
    const pdfRequestId = element.type === 'CreditorWatch'
      ? (element.json as CreditorWatchReportData).pdfRequestId
      : undefined;
    const target = bureauReportDownloadTarget(element.type, element.id, pdfRequestId);
    if (!target) {
      return;
    }
    openAuthorizedBureauReport(this.apiUrl, target.kind, target.resourceId).catch(() => {
      this.toastService.error('Unable to download report');
    });
  }

  onViewReport(element: AccreditationWebService) {
    this.viewReport.emit(element)
  }

  onViewCreditorWatchReport(element: AccreditationWebService) {
    this.dialogService.openCreditorWatchReportDialog({
      webService: element
    }).afterClosed().subscribe()
  }

  getWebServiceUpdatedTime(webService: AccreditationWebService) {
    return moment(webService.lastUpdatedTime).format("DD/MM/YYYY h:mm a");
  }

  onViewJson(element: AccreditationWebService) {
    this.dialogService.openWebServiceJsonDialog({
      webService: element
    }).afterClosed().subscribe()
  }
}
